/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  CONSOLE_INSTANCE_BASE_HOSTING_TYPE_DEDICATED,
  CONSOLE_INSTANCE_BASE_HOSTING_TYPE_MULTI_TENANTED,
  CONSOLE_INSTANCE_BASE_HOSTING_TYPE_SAAS,
} from '../Base/types/ConsoleInstanceBaseHostingType.entity.types';

/**
 * All of the possible `ConsoleInstanceFunnelbackHostingType*`'s.
 * @export
 */
export type ConsoleInstanceFunnelbackHostingType =
  | ConsoleInstanceFunnelbackHostingTypeDedicated
  | ConsoleInstanceFunnelbackHostingTypeMultiTenanted
  | ConsoleInstanceFunnelbackHostingTypeSaas;

/**
 * The type of Funnelback instance hosting type.
 * @export
 */
export type ConsoleInstanceFunnelbackHostingTypeDedicated = typeof CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_DEDICATED;

/**
 * The type of Funnelback instance hosting type.
 * @export
 */
export type ConsoleInstanceFunnelbackHostingTypeMultiTenanted =
  typeof CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_MULTI_TENANTED;

/**
 * The type of Funnelback instance hosting type.
 * @export
 */
export type ConsoleInstanceFunnelbackHostingTypeSaas = typeof CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_SAAS;

/**
 * The dedicated hosting type of the Funnelback instance.
 * @export
 */
export const CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_DEDICATED = CONSOLE_INSTANCE_BASE_HOSTING_TYPE_DEDICATED;

/**
 * The multi-tenanted hosting type of the Funnelback instance.
 * @export
 */
export const CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_MULTI_TENANTED =
  CONSOLE_INSTANCE_BASE_HOSTING_TYPE_MULTI_TENANTED;

/**
 * The saas hosting type of the Funnelback instance.
 * @export
 */
export const CONSOLE_INSTANCE_FUNNELBACK_HOSTING_TYPE_SAAS = CONSOLE_INSTANCE_BASE_HOSTING_TYPE_SAAS;
